export default __webpack_public_path__ + "static/media/Arrow.c6d2b2bb.svg";